import { render, staticRenderFns } from "./AddServicePlaceForm.vue?vue&type=template&id=6d1a0c66&scoped=true&"
import script from "./AddServicePlaceForm.vue?vue&type=script&lang=js&"
export * from "./AddServicePlaceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1a0c66",
  null
  
)

export default component.exports